module.exports = __webpack_public_path__ + "img/image-charging-station-infographic.0b4a8eaa.png";